<template>
  <!-- Same styled autocomplete as the Co-Lead "Add Missing UMR" modal. The
       canonical RiskCode list is offered as you type, but a manual cash call may
       carry a code the table does not hold yet, so free typing is allowed. -->
  <CashCallAutocompleteInput
    :value="value"
    @input="$emit('input', $event)"
    label="Risk Code"
    name="Risk Code"
    required
    rules="required"
    :options="options"
    :max-options="1000"
    sort-options
  />
</template>

<script>
import { defineComponent, ref, onMounted } from '@vue/composition-api'

import CashCallAutocompleteInput from './CashCallAutocompleteInput.vue'
import CashCallService from '@services/CashCallService'

export default defineComponent({
  name: 'CashCallFormManualRiskCode',
  components: {
    CashCallAutocompleteInput
  },
  props: {
    value: String
  },
  emits: ['input'],
  setup() {
    const options = ref([])

    const fetchRiskCodes = async () => {
      try {
        // The same canonical RiskCode table the Co-Lead "Add Missing UMR" flow
        // reads, so both paths suggest from one list rather than drifting apart.
        //
        // Guarded the way that flow guards it: the interceptor does not always
        // hand back the shape this endpoint documents (a refreshed token, or an
        // error body, arrives here as a non-array), and calling .filter on that
        // throws inside the fetch - which is what left this field with no
        // suggestions at all.
        const response = await CashCallService.getRiskCodes()

        // The payload arrives wrapped twice: axios gives response.data, and the
        // body inside it is itself {status, data: {status, message, data: [...]}}
        // - so the codes sit at .data.data.data. Walking down to the first array
        // rather than hard-coding that depth keeps this working if the extra
        // envelope is ever removed.
        let payload = response && response.data
        for (let depth = 0; depth < 4 && payload && !Array.isArray(payload); depth += 1) {
          payload = payload.data
        }

        options.value = Array.isArray(payload)
          ? [...new Set(payload.filter(Boolean))]
          : []
      } catch (err) {
        // Suggestions are a convenience, not a gate.
        console.error('Error fetching risk code suggestions', err)
      }
    }

    onMounted(fetchRiskCodes)

    return { options }
  }
})
</script>
